export default "__VITE_ASSET__xK92vnrx__"